import { Component } from '@angular/core';
import { DataSource } from '@angular/cdk';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { LeaveData } from '../../classes/leave-data.class';
import { UserService } from '../../services/user.service';
import { DialogAddLeaveComponent } from '../dialogs/dialog-add-leave.component';
import { MdDialog } from '@angular/material';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireList  } from 'angularfire2/database'
import * as firebase from 'firebase';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-leave',
  templateUrl: '../../templates/leave/leave.component.html'
})
export class LeaveComponent {

  color = 'primary';
  mode = 'determinate';

  // Data vir ons table
  displayedColumns = ['from', 'to', 'reason', 'type', 'status'];
  public leaveDatabase;
  dataSource: LeaveDataSource | null;

  constructor(db: AngularFireDatabase,userService: UserService, public dialog: MdDialog){
    this.leaveDatabase = new LeaveDatabase(db, userService);// Ons maak n nuwe database vir ons table
    
  }

  ngOnInit() {
    this.dataSource = new LeaveDataSource(this.leaveDatabase);// Ons maak 'n nuwe data source vir ons table
  }

  addLeaveDialog(){
    this.dialog.open(DialogAddLeaveComponent, {});
  }

  getVacationLeave(){
    
  }

  getFuneralLeave(){

  }

  getSickLeave(){
    
  }
}

// Hier luister ons op die "child_added" event op die realtime database en
// as 'n child bykom dan word dit gestoor in ons Subject. Dit emit dadelik 
// 'n view change as sy data verander.

export class LeaveDatabase {
  dataChange: BehaviorSubject<LeaveData[]> = new BehaviorSubject<LeaveData[]>([]);
  get data(): LeaveData[] { return this.dataChange.value; }

  constructor(db: AngularFireDatabase, userService: UserService) {
    let userId = userService.getCurrentUserId();
    let path = 'leave/' + userId + '/';
    let database = firebase.database();
    let databaseRef = database.ref();
    let leaveRef = databaseRef.child(path);
    let that = this;
    leaveRef.on('child_added', function(snapshot) {
      // somebody added leave for this user
      const copiedData = that.data.slice();
      copiedData.push(snapshot.val());
      that.dataChange.next(copiedData);//elke leave entry
    });
  }
}

export class LeaveDataSource extends DataSource<any> {
  constructor(private _leaveDatabase: LeaveDatabase) {
    super();
  }

  connect(): Observable<LeaveData[]> {
    return this._leaveDatabase.dataChange;
  }

  disconnect() {}
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/leave/leave.component.ts